var map = {
	"./DRS.png": 6163,
	"./M0NSTER.jpg": 2529,
	"./Picsart_22-10-02_16-42-33-788.jpg": 1546,
	"./United jeersey 2.2.png": 9204,
	"./alan walker.jpg": 4618,
	"./barca concept 1.png": 388,
	"./bayern jersey 1.png": 8368,
	"./bayern jersey.png": 2265,
	"./chelsea.png": 1737,
	"./f1 2.png": 9985,
	"./final render 1.png": 8165,
	"./final render 2.png": 7806,
	"./final render 3 (1).png": 981,
	"./final render 4.png": 4392,
	"./harvy.jpg": 6772,
	"./iron man.png": 3418,
	"./juventus jersey.png": 8188,
	"./kakashi post (1).png": 8826,
	"./marshmello colour.png": 4640,
	"./naruto.png": 379,
	"./psg jersey 1.png": 903,
	"./psg1.png": 3699,
	"./remaster captain america.png": 7945,
	"./ronaldo 2 (2).png": 3642,
	"./statue edit.png": 7486,
	"./tanjiro 2.png": 8691,
	"./ten hag edit2.png": 5165,
	"./thanos final.png": 6311,
	"./tried something with grad maps.png": 1997,
	"./united 2nd kit 23.png": 6532,
	"./vineeth1.jpg": 6938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2622;